// extracted by mini-css-extract-plugin
module.exports = {"outages":"OutageCountBar_outages__KKX_l","main":"OutageCountBar_main__EHZKF"};